import React from 'react'
import cx from 'classnames'


export default Li = ({children, className}) ->
  return \
  React.createElement("li", {"className": (cx "TeamReport__li", className)}, (children))
